export default __webpack_public_path__ + "img/BB_RTK_250MA_WF.6d8b51052285c875f46648c0c4ade0af.jpg";